module.exports = __webpack_public_path__ + "img/hospital.9b935898.png";